import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import { RouteConfig } from 'vue-router'
import { asyncRoutes, constantRoutes } from '@/router'
import store from '@/store'

// 判断用户权限
const hasPermission = (role: any, route: RouteConfig) => {
  if (route.name == 'Home' || route.name == 'p_home' || (route.meta && route.meta.hidden)){
    return true;
  }else{
    if (route.name) {
      return role.indexOf(route.name) !== -1;
    } else {
      return true
    }
  }
}

// 筛选异步路由
const filterAsyncRoutes = (routes: RouteConfig[], role: any) => {
  let res: RouteConfig[] = []
  routes.forEach(route => {
    // console.log(route)
    let r = { ...route }
    // console.log(r,1)
    if (hasPermission(role, r)) {
      if (r.children){
        r.children = filterAsyncRoutes(r.children, role);
      }
      res.push(r)
    }
  })
  // console.log(res)

  // console.log(role,'role')
  
  return res
}

export interface PermissionState {
  allRoutes: RouteConfig[]
  dynamicRoutes: RouteConfig[],
  apiRoutes: any
}

@Module({ dynamic: true, store, name: 'permission' })
class Permission extends VuexModule implements PermissionState {
  public dynamicRoutes: RouteConfig[] = []
  public allRoutes: RouteConfig[] = []
  public apiRoutes: any = []

  @Mutation
  private SET_ROUTES(routes: RouteConfig[]) {
    this.allRoutes = constantRoutes.concat(routes);
    this.dynamicRoutes = routes;
  }

  @Mutation
  private SET_APIROUTES(routes: any) {
    this.apiRoutes = routes;
  }

  @Action
  public setRoutes(role: any) {
    let names:any = [];
    role.map((item:any)=>{
      if (item.Sref == 'Home'){
        names.push('p_home');
      }
      names.push(item.Sref);
      
      item.EmployeeRoleChildMenuList.map((obj:any)=>{
        names.push(obj.Sref);
      })
    })
    let accessedRoutes = filterAsyncRoutes(asyncRoutes, names);
    // console.log(accessedRoutes,'123')
    this.SET_ROUTES(accessedRoutes);
    this.SET_APIROUTES(role);
  }
}

export const PermissionModule = getModule(Permission)